import React, { forwardRef } from 'react';
import { Box } from '@fiverr-private/theme';
import { ListItemIconProps } from './types';

const ListItemIcon = forwardRef<HTMLElement, ListItemIconProps>(
  ({ children, marginTop = '0.5', ...restProps }: ListItemIconProps, ref) => (
    <Box ref={ref} as="span" flexShrink="0" marginTop={marginTop} {...restProps}>
      {children}
    </Box>
  )
);

ListItemIcon.displayName = 'ListItemIcon';

export default ListItemIcon;
